// Traducciones específicas de la Wiki
// Separado del archivo principal para mejor organización
// Idiomas soportados: Inglés (en), Español (es), Portugués (pt)

export const wikiTranslations = {
    // === SECCIÓN INTRO ===
    WIKI_WELCOME_TITLE: {
        en: "Welcome to Config Strike",
        es: "Bienvenido a Config Strike",
        pt: "Bem-vindo ao Config Strike"
    },
    WIKI_PAGE_TITLE: {
        en: "Knowledge Base",
        es: "Base de Conocimientos",
        pt: "Base de Conhecimento"
    },
    WIKI_PAGE_SUBTITLE: {
        en: "Technical documentation and guides for game configuration.",
        es: "Documentación técnica y guías para la configuración del juego.",
        pt: "Documentação técnica e guias para configuração do jogo."
    },
    WIKI_INTRO_P1: {
        en: "The ultimate tool to customize your Counter-Strike 2 experience. Our application generates an optimized and clean configuration file (",
        es: "La herramienta definitiva para personalizar tu experiencia en Counter-Strike 2. Nuestra aplicación genera un archivo de configuración (",
        pt: "A ferramenta definitiva para personalizar sua experiência no Counter-Strike 2. Nosso aplicativo gera um arquivo de configuração ("
    },
    WIKI_INTRO_P2: {
        en: "autoexec.cfg",
        es: "autoexec.cfg",
        pt: "autoexec.cfg"
    },
    WIKI_INTRO_P3: {
        en: ") optimized and clean, eliminating the need to manually write commands in the console.",
        es: ") optimizado y limpio, eliminando la necesidad de escribir comandos manualmente en la consola.",
        pt: ") otimizado e limpo, eliminando a necessidade de escrever comandos manualmente no console."
    },

    // === PASOS ===
    WIKI_STEP_1_TITLE: {
        en: "1. Customize",
        es: "1. Personaliza",
        pt: "1. Personalize"
    },
    WIKI_STEP_1_DESC: {
        en: "Navigate through the modules (Crosshairs, Viewmodel, Audio, Binds) and adjust each parameter visually.",
        es: "Navega por los módulos (Miras, Viewmodel, Audio, Binds) y ajusta cada parámetro visualmente.",
        pt: "Navegue pelos módulos (Miras, Viewmodel, Áudio, Binds) e ajuste cada parâmetro visualmente."
    },
    WIKI_STEP_2_TITLE: {
        en: "2. Preview",
        es: "2. Previsualiza",
        pt: "2. Visualize"
    },
    WIKI_STEP_2_DESC: {
        en: "See your changes in real-time with our interactive previews before applying.",
        es: "Observa los cambios en tiempo real con nuestras previsualizaciones interactivas antes de aplicar.",
        pt: "Veja suas alterações em tempo real com nossas visualizações interativas antes de aplicar."
    },
    WIKI_STEP_3_TITLE: {
        en: "3. Export",
        es: "3. Exporta",
        pt: "3. Exporte"
    },
    WIKI_STEP_3_DESC: {
        en: "Download your autoexec.cfg file and place it in the CS2 folder to automatically load your config.",
        es: "Descarga tu archivo autoexec.cfg y colócalo en la carpeta de CS2 para cargar tu config automáticamente.",
        pt: "Baixe seu arquivo autoexec.cfg e coloque-o na pasta do CS2 para carregar sua config automaticamente."
    },

    // === SECCIONES ===
    WIKI_SECTION_CROSSHAIR: {
        en: "Crosshair",
        es: "Miras (Crosshair)",
        pt: "Mira (Crosshair)"
    },
    WIKI_SECTION_VIEWMODEL: {
        en: "Viewmodel (Weapon Position)",
        es: "Viewmodel (Posición del Arma)",
        pt: "Viewmodel (Posição da Arma)"
    },
    WIKI_SECTION_MOUSE: {
        en: "Mouse & Sensitivity",
        es: "Mouse & Sensibilidad",
        pt: "Mouse & Sensibilidade"
    },
    WIKI_SECTION_HUD: {
        en: "HUD & Radar",
        es: "HUD & Radar",
        pt: "HUD & Radar"
    },
    WIKI_SECTION_GRAPHICS: {
        en: "Graphics & Performance",
        es: "Gráficos & Rendimiento",
        pt: "Gráficos & Desempenho"
    },
    WIKI_SECTION_PRACTICE: {
        en: "Practice Mode",
        es: "Modo Práctica",
        pt: "Modo Prática"
    },
    WIKI_SECTION_LAUNCH: {
        en: "Launch Options",
        es: "Opciones de Lanzamiento (Launch Options)",
        pt: "Opções de Inicialização (Launch Options)"
    },
    WIKI_PRACTICE_WARNING: {
        en: "PRIVATE SERVERS ONLY",
        es: "SOLO SERVIDORES PRIVADOS",
        pt: "APENAS SERVIDORES PRIVADOS"
    },

    // === CROSSHAIR COMMANDS ===
    WIKI_CROSSHAIR_SIZE_DESC: {
        en: "Defines the length of the crosshair lines. A value of 0 makes the lines disappear, while high values make it more visible at long distances.",
        es: "Define la longitud de las líneas que forman la mira. Un valor de 0 hace desaparecer las líneas, mientras que valores altos la hacen más visible a largas distancias.",
        pt: "Define o comprimento das linhas da mira. Um valor de 0 faz as linhas desaparecerem, enquanto valores altos a tornam mais visível a longas distâncias."
    },
    WIKI_CROSSHAIR_GAP_DESC: {
        en: "Controls the empty space in the center of the crosshair. Negative values close the crosshair more, while positive ones open it. Essential for seeing heads at distance.",
        es: "Controla el espacio vacío en el centro de la mira. Valores negativos cierran más la mira, mientras que positivos la abren. Esencial para ver cabezas a distancia.",
        pt: "Controla o espaço vazio no centro da mira. Valores negativos fecham mais a mira, enquanto positivos a abrem. Essencial para ver cabeças à distância."
    },
    WIKI_CROSSHAIR_THICKNESS_DESC: {
        en: "Adjusts the thickness of the lines. Players with low resolutions usually prefer smaller thicknesses (0.5 or 0) to not block vision.",
        es: "Ajusta el grosor de las líneas. Jugadores con resoluciones bajas suelen preferir grosores menores (0.5 o 0) para no tapar visión.",
        pt: "Ajusta a espessura das linhas. Jogadores com resoluções baixas geralmente preferem espessuras menores (0.5 ou 0) para não bloquear a visão."
    },
    WIKI_CROSSHAIR_STYLE_DESC: {
        en: "Defines dynamic behavior. \"4\" is completely static (professional standard), \"5\" opens when shooting, \"2\" is the classic dynamic.",
        es: "Define el comportamiento dinámico. \"4\" es completamente estático (profesional estándar), \"5\" se abre al disparar, \"2\" es el clásico dinámico.",
        pt: "Define o comportamento dinâmico. \"4\" é completamente estático (padrão profissional), \"5\" abre ao atirar, \"2\" é o dinâmico clássico."
    },
    WIKI_CROSSHAIR_DRAWOUTLINE_DESC: {
        en: "Adds a black border around the crosshair to improve contrast on light textures.",
        es: "Añade un borde negro alrededor de la mira para mejorar el contraste en texturas claras.",
        pt: "Adiciona uma borda preta ao redor da mira para melhorar o contraste em texturas claras."
    },
    WIKI_CROSSHAIR_OUTLINETHICKNESS_DESC: {
        en: "Controls the thickness of the black border surrounding the crosshair (if drawoutline is active).",
        es: "Controla el grosor del borde negro que rodea la mira (si drawoutline está activo).",
        pt: "Controla a espessura da borda preta ao redor da mira (se drawoutline estiver ativo)."
    },
    WIKI_CROSSHAIR_COLOR_DESC: {
        en: "Sets the base color. \"1\"=Green, \"2\"=Yellow, \"3\"=Blue, \"4\"=Cyan, \"5\"=Custom (RGB).",
        es: "Establece el color base. \"1\"=Verde, \"2\"=Amarillo, \"3\"=Azul, \"4\"=Cian, \"5\"=Personalizado (RGB).",
        pt: "Define a cor base. \"1\"=Verde, \"2\"=Amarelo, \"3\"=Azul, \"4\"=Ciano, \"5\"=Personalizado (RGB)."
    },
    WIKI_CROSSHAIR_RGB_DESC: {
        en: "Defines the Red, Green, and Blue components of the crosshair when using custom color (cl_crosshaircolor 5).",
        es: "Define los componentes Rojo, Verde y Azul de la mira cuando se usa el color personalizado (cl_crosshaircolor 5).",
        pt: "Define os componentes Vermelho, Verde e Azul da mira ao usar cor personalizada (cl_crosshaircolor 5)."
    },
    WIKI_CROSSHAIR_ALPHA_DESC: {
        en: "Controls crosshair transparency. 255 is fully opaque, 0 is invisible.",
        es: "Controla la transparencia de la mira. 255 es totalmente opaco, 0 es invisible.",
        pt: "Controla a transparência da mira. 255 é totalmente opaco, 0 é invisível."
    },
    WIKI_CROSSHAIR_DOT_DESC: {
        en: "Adds a dot in the exact center of the crosshair.",
        es: "Añade un punto en el centro exacto de la mira.",
        pt: "Adiciona um ponto no centro exato da mira."
    },
    WIKI_CROSSHAIR_T_DESC: {
        en: "Transforms the crosshair into a \"T\", removing the top line.",
        es: "Transforma la mira en una \"T\", eliminando la línea superior.",
        pt: "Transforma a mira em um \"T\", removendo a linha superior."
    },
    WIKI_CROSSHAIR_RECOIL_DESC: {
        en: "If active, the crosshair follows the weapon's recoil (physically moves on screen).",
        es: "Si está activo, la mira sigue el retroceso del arma (físicamente se mueve en la pantalla).",
        pt: "Se ativo, a mira segue o recuo da arma (move-se fisicamente na tela)."
    },
    WIKI_CROSSHAIR_SNIPER_WIDTH_DESC: {
        en: "Thickness of crosshair lines when using sniper zoom option.",
        es: "Grosor de las líneas de la mira al usar la opción de zoom de los francotiradores.",
        pt: "Espessura das linhas da mira ao usar a opção de zoom dos franco-atiradores."
    },
    WIKI_CROSSHAIR_FRIENDLY_WARNING_DESC: {
        en: "Shows a warning about teammates when aiming at them.",
        es: "Muestra un aviso sobre compañeros de equipo al apuntarles.",
        pt: "Mostra um aviso sobre companheiros de equipe ao mirar neles."
    },

    // === VIEWMODEL COMMANDS ===
    WIKI_VIEWMODEL_FOV_DESC: {
        en: "Weapon model field of view. Increasing it (Max 68) makes the weapon appear further away and take up less screen space.",
        es: "Campo de visión del modelo del arma. Aumentarlo (Max 68) hace que el arma parezca más alejada y ocupe menos pantalla.",
        pt: "Campo de visão do modelo da arma. Aumentá-lo (Máx 68) faz a arma parecer mais distante e ocupar menos espaço na tela."
    },
    WIKI_VIEWMODEL_X_DESC: {
        en: "Horizontal weapon position. Positive values move the weapon to the right, negative towards center/left.",
        es: "Posición horizontal del arma. Valores positivos mueven el arma a la derecha, negativos hacia el centro/izquierda.",
        pt: "Posição horizontal da arma. Valores positivos movem a arma para a direita, negativos para o centro/esquerda."
    },
    WIKI_VIEWMODEL_Y_DESC: {
        en: "Weapon depth (\"longer arms\"). High values move the weapon away from the body. Max 2.0.",
        es: "Profundidad del arma (\"brazos más largos\"). Valores altos alejan el arma del cuerpo. Max 2.0.",
        pt: "Profundidade da arma (\"braços mais longos\"). Valores altos afastam a arma do corpo. Máx 2.0."
    },
    WIKI_VIEWMODEL_Z_DESC: {
        en: "Vertical weapon height. Negative values lower the weapon, clearing more vision at the bottom of the screen.",
        es: "Altura vertical del arma. Valores negativos bajan el arma, despejando más visión en la parte inferior de la pantalla.",
        pt: "Altura vertical da arma. Valores negativos abaixam a arma, liberando mais visão na parte inferior da tela."
    },
    WIKI_VIEWMODEL_LEFTHANDED_DESC: {
        en: "Switches weapon to left or right hand. Many players prefer left if their dominant eye is the right one.",
        es: "Cambia el arma a la mano izquierda o derecha. Muchos jugadores prefieren la izquierda si su ojo dominante es el derecho.",
        pt: "Muda a arma para a mão esquerda ou direita. Muitos jogadores preferem a esquerda se seu olho dominante é o direito."
    },

    // === MOUSE COMMANDS ===
    WIKI_MOUSE_SENSITIVITY_DESC: {
        en: "Base sensitivity multiplier. Multiplies by your mouse DPI to get the real eDPI.",
        es: "Multiplicador base de la sensibilidad. Se multiplica por el DPI de tu mouse para obtener el eDPI real.",
        pt: "Multiplicador base de sensibilidade. Multiplica pelo DPI do seu mouse para obter o eDPI real."
    },
    WIKI_MOUSE_ZOOM_SENS_DESC: {
        en: "Sensitivity multiplier when using scope (AWP, Scout). \"0.818933\" is technically the 1:1 ratio with hipfire, but \"1.0\" is the standard.",
        es: "Multiplicador de sensibilidad al usar la mira (AWP, Scout). \"0.818933\" es técnicamente el ratio 1:1 con la cadera, pero \"1.0\" es el estándar.",
        pt: "Multiplicador de sensibilidade ao usar mira (AWP, Scout). \"0.818933\" é tecnicamente a proporção 1:1 com hipfire, mas \"1.0\" é o padrão."
    },
    WIKI_MOUSE_YAW_PITCH_DESC: {
        en: "Defines how many degrees the camera rotates for each \"dot\" of horizontal or vertical movement. 0.022 is the default.",
        es: "Define cuántos grados gira la cámara por cada \"dot\" de movimiento horizontal o vertical. 0.022 es el default.",
        pt: "Define quantos graus a câmera gira para cada \"ponto\" de movimento horizontal ou vertical. 0.022 é o padrão."
    },
    WIKI_MOUSE_RAWINPUT_DESC: {
        en: "If enabled, the game reads data directly from the mouse, bypassing Windows settings.",
        es: "Si está activado, el juego lee los datos directamente del ratón, ignorando la configuración de Windows.",
        pt: "Se ativado, o jogo lê dados diretamente do mouse, ignorando as configurações do Windows."
    },

    // === HUD & RADAR COMMANDS ===
    WIKI_HUD_SCALING_DESC: {
        en: "Global interface scale. Low values (0.5) make the HUD smaller and less intrusive.",
        es: "Escala global de la interfaz. Valores bajos (0.5) hacen el HUD más pequeño y menos intrusivo.",
        pt: "Escala global da interface. Valores baixos (0.5) tornam o HUD menor e menos intrusivo."
    },
    WIKI_HUD_COLOR_DESC: {
        en: "Color of interface elements (ammo, health). There is a range of colors predefined by the game.",
        es: "Color de los elementos de la interfaz (munición, vida). Hay un rango de colores predefinidos por el juego.",
        pt: "Cor dos elementos da interface (munição, vida). Há uma gama de cores predefinidas pelo jogo."
    },
    WIKI_RADAR_SCALE_DESC: {
        en: "Internal radar zoom. Low values (0.35) allow seeing more of the map in the minimap without opening the full map.",
        es: "Zoom interno del radar. Valores bajos (0.35) permiten ver más parte del mapa en el minimapa sin tener que abrir el mapa completo.",
        pt: "Zoom interno do radar. Valores baixos (0.35) permitem ver mais do mapa no minimapa sem abrir o mapa completo."
    },
    WIKI_HUD_RADAR_SCALE_DESC: {
        en: "Size of the radar on screen (the circle itself), independent of zoom.",
        es: "Tamaño del radar en la pantalla (el círculo en sí), independiente del zoom.",
        pt: "Tamanho do radar na tela (o círculo em si), independente do zoom."
    },
    WIKI_RADAR_CENTERED_DESC: {
        en: "If set to \"0\", the radar doesn't center on you, allowing you to see more map in the direction you're not looking.",
        es: "Si está en \"0\", el radar no se centra en ti, permitiendo ver más mapa en la dirección hacia la que no estás mirando.",
        pt: "Se definido como \"0\", o radar não se centraliza em você, permitindo ver mais do mapa na direção que você não está olhando."
    },
    WIKI_RADAR_ROTATE_DESC: {
        en: "If enabled, radar rotates with you. Some prefer it fixed (North always up) to learn the maps.",
        es: "Si activado, el radar gira contigo. Algunos prefieren que esté fijo (Norte siempre arriba) para aprenderse los mapas.",
        pt: "Se ativado, o radar gira com você. Alguns preferem fixo (Norte sempre para cima) para aprender os mapas."
    },
    WIKI_SHOWLOADOUT_DESC: {
        en: "Keeps the inventory always visible on screen.",
        es: "Mantiene el inventario siempre visible en la pantalla.",
        pt: "Mantém o inventário sempre visível na tela."
    },
    WIKI_RADAR_ICON_SCALE_DESC: {
        en: "Size of icons (players, bomb) on the radar.",
        es: "Tamaño de los iconos (jugadores, bomba) en el radar.",
        pt: "Tamanho dos ícones (jogadores, bomba) no radar."
    },
    WIKI_TEAMMATE_COLORS_DESC: {
        en: "Shows different colors for each teammate on radar and killfeed (Yellow, Orange, Blue, etc).",
        es: "Muestra colores distintos para cada compañero de equipo en el radar y killfeed (Amarillo, Naranja, Azul, etc).",
        pt: "Mostra cores diferentes para cada companheiro de equipe no radar e killfeed (Amarelo, Laranja, Azul, etc)."
    },

    // === GRAPHICS COMMANDS ===
    WIKI_FPS_MAX_DESC: {
        en: "Frame rate limit. \"0\" removes the limit (recommended for minimum latency), though some prefer to cap it (e.g. 400) for consistency.",
        es: "Límite de fotogramas por segundo. \"0\" elimina el límite (recomendado para mínima latencia), aunque algunos prefieren limitarlo (ej. 400) para consistencia.",
        pt: "Limite de taxa de quadros. \"0\" remove o limite (recomendado para latência mínima), embora alguns prefiram limitá-lo (ex. 400) para consistência."
    },
    WIKI_TRACERS_DESC: {
        en: "Shows bullet tracers from your own weapon. Disabling it can help control recoil visually without distractions, though you lose reference.",
        es: "Muestra las balas trazadoras de tu propia arma. Desactivarlo puede ayudar a controlar el recoil visualmente sin distracciones, aunque pierdes referencia.",
        pt: "Mostra os rastros de balas da sua própria arma. Desativá-lo pode ajudar a controlar o recuo visualmente sem distrações, embora você perca referência."
    },
    WIKI_DYNAMIC_DESC: {
        en: "Controls dynamic lighting when shooting.",
        es: "Controla la luz dinámica al disparar.",
        pt: "Controla a iluminação dinâmica ao atirar."
    },
    WIKI_ANIMATED_AVATARS_DESC: {
        en: "Enables or disables animated Steam avatars in-game to improve performance.",
        es: "Activa o desactiva avatares animados de Steam en el juego para mejorar rendimiento.",
        pt: "Ativa ou desativa avatares animados do Steam no jogo para melhorar o desempenho."
    },
    WIKI_RAGDOLL_DESC: {
        en: "Adjustment related to ragdoll physics.",
        es: "Ajuste relacionado con la física de los cuerpos (ragdolls).",
        pt: "Ajuste relacionado à física de bonecos (ragdolls)."
    },
    WIKI_LOW_LATENCY_DESC: {
        en: "Related to NVIDIA Reflex. Helps reduce system latency by synchronizing CPU and GPU.",
        es: "Relacionado con NVIDIA Reflex. Ayuda a reducir la latencia del sistema sincronizando CPU y GPU.",
        pt: "Relacionado ao NVIDIA Reflex. Ajuda a reduzir a latência do sistema sincronizando CPU e GPU."
    },

    // === PRACTICE COMMANDS ===
    WIKI_SV_CHEATS_DESC: {
        en: "Master command that enables cheats on the server. Necessary for noclip, grenade trajectory, god mode, etc.",
        es: "Comando maestro que habilita trucos en el servidor. Necesario para noclip, trayectoria de granadas, god mode, etc.",
        pt: "Comando mestre que habilita trapaças no servidor. Necessário para noclip, trajetória de granadas, god mode, etc."
    },
    WIKI_NOCLIP_DESC: {
        en: "Allows you to fly and go through walls. Fundamental for practicing smokes or moving quickly around the map.",
        es: "Te permite volar y atravesar paredes. Fundamental para practicar humos o moverse rápido por el mapa.",
        pt: "Permite voar e atravessar paredes. Fundamental para praticar smokes ou se mover rapidamente pelo mapa."
    },
    WIKI_RETHROW_GRENADE_DESC: {
        en: "Re-throws the last grenade from the exact same position. Ideal for testing pop-flashes.",
        es: "Vuelve a lanzar la última granada que tiraste desde la misma posición exacta. Ideal para probar pop-flashes.",
        pt: "Relança a última granada da mesma posição exata. Ideal para testar pop-flashes."
    },
    WIKI_INFINITE_AMMO_DESC: {
        en: "\"1\" infinite ammo without reloading. \"2\" infinite ammo with reload (useful for practicing recoil).",
        es: "\"1\" munición infinita sin recargar. \"2\" munición infinita con recarga (útil para practicar recoil).",
        pt: "\"1\" munição infinita sem recarregar. \"2\" munição infinita com recarga (útil para praticar recuo)."
    },
    WIKI_GRENADE_TRAJECTORY_DESC: {
        en: "Shows a PIP (Picture-in-Picture) window of where the grenade will land.",
        es: "Muestra una ventana PIP (Picture-in-Picture) de dónde caerá la granada.",
        pt: "Mostra uma janela PIP (Picture-in-Picture) de onde a granada cairá."
    },
    WIKI_WARMUP_END_DESC: {
        en: "Ends warmup immediately and starts the round/game.",
        es: "Termina el calentamiento inmediatamente y comienza la ronda/juego.",
        pt: "Termina o aquecimento imediatamente e inicia a rodada/jogo."
    },
    WIKI_RESTART_GAME_DESC: {
        en: "Completely restarts the match after X seconds.",
        es: "Reinicia la partida completamente después de X segundos.",
        pt: "Reinicia completamente a partida após X segundos."
    },
    WIKI_BOT_KICK_DESC: {
        en: "Kicks all bots from the server.",
        es: "Expulsa a todos los bots del servidor.",
        pt: "Expulsa todos os bots do servidor."
    },
    WIKI_BOT_ADD_DESC: {
        en: "Adds a bot to the terrorist or counter-terrorist team.",
        es: "Añade un bot al equipo terrorista o antiterrorista.",
        pt: "Adiciona um bot ao time terrorista ou contra-terrorista."
    },
    WIKI_BOT_STOP_DESC: {
        en: "Freezes all bots in their current position.",
        es: "Congela a todos los bots en su posición actual.",
        pt: "Congela todos os bots em sua posição atual."
    },
    WIKI_BOT_PLACE_DESC: {
        en: "Places a bot exactly where you are looking.",
        es: "Coloca un bot exactamente donde estás mirando.",
        pt: "Coloca um bot exatamente onde você está olhando."
    },

    // === LAUNCH OPTIONS ===
    WIKI_EXEC_AUTOEXEC_DESC: {
        en: "The most important command. Forces the game to load your custom configuration every time you start CS2.",
        es: "El comando más importante. Obliga al juego a cargar tu configuración personalizada cada vez que inicias CS2.",
        pt: "O comando mais importante. Força o jogo a carregar sua configuração personalizada toda vez que você inicia o CS2."
    },
    WIKI_NOVID_DESC: {
        en: "Skips the Valve intro when starting the game, saving a few seconds when opening CS2.",
        es: "Salta la intro de Valve al iniciar el juego, ahorrando unos segundos al abrir CS2.",
        pt: "Pula a intro da Valve ao iniciar o jogo, economizando alguns segundos ao abrir o CS2."
    },
    WIKI_HIGH_DESC: {
        en: "Gives \"High\" priority to CS2 process in Windows. May improve FPS on some systems, but cause instability on others.",
        es: "Da prioridad \"Alta\" al proceso de CS2 en Windows. Puede mejorar FPS en algunos sistemas, pero causar inestabilidad en otros.",
        pt: "Dá prioridade \"Alta\" ao processo do CS2 no Windows. Pode melhorar o FPS em alguns sistemas, mas causar instabilidade em outros."
    },
    WIKI_FREQ_DESC: {
        en: "Forces the monitor to use a specific refresh rate (Hz). Useful if the game doesn't automatically detect your 144Hz/240Hz.",
        es: "Fuerza al monitor a usar una tasa de refresco específica (Hz). Útil si el juego no detecta tus 144Hz/240Hz automáticamente.",
        pt: "Força o monitor a usar uma taxa de atualização específica (Hz). Útil se o jogo não detecta automaticamente seus 144Hz/240Hz."
    },
    WIKI_CONSOLE_DESC: {
        en: "Opens developer console automatically when starting the game.",
        es: "Abre la consola de desarrollador automáticamente al iniciar el juego.",
        pt: "Abre o console do desenvolvedor automaticamente ao iniciar o jogo."
    },
    WIKI_FULLSCREEN_DESC: {
        en: "Forces the game to start in Fullscreen mode.",
        es: "Fuerza el juego a iniciar en modo Pantalla Completa.",
        pt: "Força o jogo a iniciar em modo Tela Cheia."
    },
    WIKI_RESOLUTION_DESC: {
        en: "Forces a specific resolution (width and height). Ex: -w 1920 -h 1080.",
        es: "Fuerza una resolución específica (ancho y alto). Ej: -w 1920 -h 1080.",
        pt: "Força uma resolução específica (largura e altura). Ex: -w 1920 -h 1080."
    },

    // === TÉRMINOS COMUNES ===
    WIKI_YELLOW: {
        en: "Yellow",
        es: "Amarillo",
        pt: "Amarelo"
    },
    WIKI_DARK_BLUE: {
        en: "Dark Blue",
        es: "Azul Oscuro",
        pt: "Azul Escuro"
    },
    WIKI_LIGHT_BLUE: {
        en: "Light Blue",
        es: "Celeste",
        pt: "Azul Claro"
    },

    // Traducciones que ya existían en CrosshairWiki
    CROSSHAIR_STYLES: {
        en: "Crosshair Styles",
        es: "Estilos de la Mira",
        pt: "Estilos da Mira"
    },
    STYLES_DESC: {
        en: "This command allows you to select the overall crosshair style. The available styles are:",
        es: "Este comando permite seleccionar el estilo general de la mira. Los estilos disponibles son:",
        pt: "Esse comando permite selecionar o estilo geral da mira. Os estilos disponíveis são:"
    },
    STYLE_0: {
        en: "0 - Default Dynamic: Expands when you move or shoot.",
        es: "0 - Mira dinámica por defecto: Se expande cuando te mueves o disparas.",
        pt: "0 - Mira dinâmica padrão: Expande quando você se move ou atira."
    },
    STYLE_1: {
        en: "1 - Default Static: Does not expand (not available in CS2).",
        es: "1 - Mira estática por defecto: No se expande (no disponible en CS2).",
        pt: "1 - Mira estática padrão: Não expande (não disponível no CS2)."
    },
    STYLE_2: {
        en: "2 - Classic Dynamic: Expands/contracts based on movement.",
        es: "2 - Mira clásica dinámica: Se expande/contrae según el movimiento.",
        pt: "2 - Mira clássica dinâmica: Expande/contrai com base no movimento."
    },
    STYLE_3: {
        en: "3 - Classic Dynamic: Not fully implemented.",
        es: "3 - Mira clásica dinámica: No completamente implementada.",
        pt: "3 - Mira clássica dinâmica: Não totalmente implementada."
    },
    STYLE_4: {
        en: "4 - Classic Static: Does not expand.",
        es: "4 - Mira clásica estática: No se expande.",
        pt: "4 - Mira clássica estática: Não expande."
    },
    STYLE_5: {
        en: "5 - Dynamic with less expansion.",
        es: "5 - Mira dinámica con menor expansión.",
        pt: "5 - Mira dinâmica com menos expansão."
    },
    DEFAULT_VALUES: {
        en: "Default values for",
        es: "Valores por defecto para",
        pt: "Valores padrão para"
    },
    COLOR_ADJUSTMENTS: {
        en: "Color Adjustment Commands",
        es: "Comandos para Ajustes de Color",
        pt: "Comandos de Ajuste de Cor"
    },
    COLOR_DESC: {
        en: "This command changes the crosshair color. The values are:",
        es: "Este comando cambia el color de la mira. Los valores son:",
        pt: "Este comando altera a cor da mira. Os valores são:"
    },
    RGB_DESC: {
        en: "Adjusts RGB values for color customization. The maximum values are 255 for each color (Red, Green, Blue).",
        es: "Ajusta los valores RGB para personalizar el color. Los valores máximos son 255 para cada color (Rojo, Verde, Azul).",
        pt: "Ajusta os valores RGB para personalização de cor. Os valores máximos são 255 para cada cor (Vermelho, Verde, Azul)."
    },
    SIZE_THICK_TRANS: {
        en: "Size, Thickness and Transparency",
        es: "Tamaño, Grosor y Transparencia",
        pt: "Tamanho, Espessura e Transparência"
    },
    SIZE_DESC_WIKI: {
        en: "Controls the size of the lines that form the crosshair. The default value is 5 and you can adjust it between -20 and 20.",
        es: "Controla el tamaño de las líneas que forman la mira. El valor por defecto es 5 y puedes ajustarlo entre -20 y 20.",
        pt: "Controla o tamanho das linhas que formam a mira. O valor padrão é 5 e você pode ajustá-lo entre -20 e 20."
    },
    THICKNESS_DESC_WIKI: {
        en: "Adjusts the thickness of the crosshair lines. The default value is 0.5, with a range from -2 to 6.",
        es: "Ajusta el grosor de las líneas de la mira. El valor por defecto es 0.5, con un rango de -2 a 6.",
        pt: "Ajusta a espessura das linhas da mira. O valor padrão é 0.5, com um intervalo de -2 a 6."
    },
    ALPHA_DESC_WIKI: {
        en: "Controls the crosshair transparency. The default value is 200, with a range between 10 and 250.",
        es: "Controla la transparencia de la mira. El valor por defecto es 200, con un rango entre 10 y 250.",
        pt: "Controla a transparência da mira. O valor padrão é 200, com um intervalo entre 10 e 250."
    },
    GAP_MODIFICATION: {
        en: "Gap Modification",
        es: "Modificación del Gap",
        pt: "Modificação do Gap"
    },
    GAP_DESC_WIKI: {
        en: "Adjusts the space between the crosshair lines. The default value is 1, with a range between -10 and 10.",
        es: "Ajusta el espacio entre las líneas de la mira. El valor por defecto es 1, con un rango entre -10 y 10.",
        pt: "Ajusta o espaço entre as linhas da mira. O valor padrão é 1, com um intervalo entre -10 e 10."
    },
    GAP_WEAPON_DESC: {
        en: "Dynamically adjusts the gap size based on the weapon you are using. Use 1 to enable and 0 to disable.",
        es: "Ajusta dinámicamente el tamaño del gap según el arma que estés usando. Usa 1 para activarlo y 0 para desactivarlo.",
        pt: "Ajusta dinamicamente o tamanho do gap com base na arma que você está usando. Use 1 para ativar e 0 para desativar."
    },
    CROSSHAIR_DYNAMISM: {
        en: "Crosshair Dynamism",
        es: "Dinamismo de la Mira",
        pt: "Din Dinamismo da Mira"
    },
    DYNAMIC_INNER_DESC: {
        en: "Adjusts the transparency of the inner part of the crosshair with style 2. Values range from 0 to 1.",
        es: "Ajusta la transparencia de la parte interna de la mira con el estilo 2. Los valores van de 0 a 1.",
        pt: "Ajusta a transparência da parte interna da mira com estilo 2. Os valores variam de 0 a 1."
    },
    DYNAMIC_OUTER_DESC: {
        en: "Adjusts the transparency of the outer part of the crosshair in style 2. Values range from 0.3 to 1.",
        es: "Ajusta la transparencia de la parte externa de la mira en el estilo 2. Los valores van de 0.3 a 1.",
        pt: "Ajusta a transparência da parte externa da mira no estilo 2. Os valores variam de 0.3 a 1."
    },
    OTHER_DETAILS: {
        en: "Other Details",
        es: "Otros Detalles",
        pt: "Outros Detalhes"
    },
    DOT_DESC: {
        en: "Adds a dot in the center of the crosshair. Use 1 to enable and 0 to disable.",
        es: "Añade un punto en el centro de la mira. Usa 1 para activarlo y 0 para desactivarlo.",
        pt: "Adiciona um ponto no centro da mira. Use 1 para ativar e 0 para desativar."
    },
    SNIPER_WIDTH_DESC_WIKI: {
        en: "Adjusts the thickness of the crosshair lines when using sniper rifles. The default value is 1, with a range from 0 to 20.",
        es: "Ajusta el grosor de las líneas de la mira cuando usas rifles de francotirador. El valor por defecto es 1, con un rango de 0 a 20.",
        pt: "Ajusta a espessura das linhas da mira ao usar rifles de precisão. O valor padrão é 1, com um intervalo de 0 a 20."
    },
    WIKI_TITLE: {
        en: "CS2 Crosshair Commands",
        es: "Comandos de Mira en CS2",
        pt: "Comandos de Mira no CS2"
    },
    WIKI_INTRO: {
        en: "In Counter-Strike 2 (CS2), crosshair customization is essential to improve accuracy and adapt it to your gameplay preferences. Below, we offer a complete description of all commands you can use to modify the crosshair through the console, along with a detailed explanation of each one.",
        es: "En Counter-Strike 2 (CS2), la personalización de la mira es esencial para mejorar la precisión y adaptarla a tus preferencias de juego. A continuación, te ofrecemos una descripción completa de todos los comandos que puedes utilizar para modificar la mira a través de la consola, junto con una explicación detallada de cada uno.",
        pt: "No Counter-Strike 2 (CS2), a personalização da mira é essencial para melhorar a precisão e adaptá-la às suas preferências de jogo. Abaixo, oferecemos uma descrição completa de todos os comandos que você pode usar para modificar a mira através do console, junto com uma explicação detalhada de cada um."
    }
};
